import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '../rem'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store' 
import axios from 'axios'
// import './assets/fonts/fonts.scss'
Vue.config.productionTip = false

Vue.use(ElementUI);
new Vue({
  router,
  el: '#app',
  store,
  render: h => h(App)
}).$mount('#app')
